var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.00374V13.2666C14 13.6857 13.7133 14 13.3311 14H0.668942C0.286689 14 0 13.6857 0 13.2666V2.00374C0 1.58466 0.286689 1.27035 0.668942 1.27035H3.48805V0.589336C3.48805 -0.196445 4.53925 -0.196445 4.53925 0.589336V1.27035H9.46075V0.589336C9.46075 -0.196445 10.5119 -0.196445 10.5119 0.589336V1.27035H13.3311C13.7133 1.27035 14 1.58466 14 2.00374ZM4.53925 2.42283V2.78952C4.53925 3.5753 3.48805 3.5753 3.48805 2.78952V2.42283H1.09898V4.41347H12.9488V2.42283H10.5119V2.78952C10.5119 3.5753 9.46075 3.5753 9.46075 2.78952V2.42283H4.53925ZM12.9488 5.61834H1.09898V12.8475H12.9488V5.61834Z",
    fill: "#B1C2CF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.8ae9703289bb9c1eb08ea30639cb293c.svg";
export { ForwardRef as ReactComponent };